import React from 'react';
import { useUserContext } from '@sierralabs/user-ui';
import * as Styled from './plugins/login/Login.styled';
import { Typography } from '@material-ui/core';
const SiteNoutFoundPage = () => {
    const { user } = useUserContext();
    // TODO: check user permissions
    return (React.createElement(Styled.StyledLoginContainer, { className: 'not-found-page' },
        React.createElement(Styled.StyledLoginCard, null,
            React.createElement("img", { src: '/assets/sl-logo@2x.png', alt: 'Sierra Labs', className: 'logo' }),
            React.createElement("h2", null, user ? 'Route not found' : 'Page not found'),
            React.createElement(Typography, { variant: 'body2' }, user
                ? 'Please check if the route is properly configured.'
                : 'The page does not exist.'))));
};
export default SiteNoutFoundPage;
//# sourceMappingURL=SiteNotFoundPage.js.map